import React from 'react';
import PropTypes from 'prop-types';
import Container from '@mui/material/Container';
import makeStyles from '@mui/styles/makeStyles';
import { useHistory } from 'react-router-dom';
import { NavBar, TabBar, CardOnFileNotification } from 'components/elements';
import { useWebSocket, useProfile, useOrganization } from 'hooks';
import { routes } from 'const';
import Styles from './styles';

const useStyles = makeStyles(Styles);

function Layout({ children }) {
  useWebSocket();
  const classes = useStyles();
  const profile = useProfile();
  const organization = useOrganization();
  const history = useHistory();

  if (profile.data?.termsConsented === false) {
    history.push(routes.termsandcondition);
  }

  return (
    <Container component="main" classes={{ root: classes.fullWidthContainer }}>
      <>
        <NavBar />
        <TabBar />
      </>
      <main className={classes.content}>
        {organization.data.showCardOnFileAlertsInPatientPortal && profile.data?.cardOnFileEnabled === 'N' && <CardOnFileNotification />}
        {children}
      </main>
    </Container>
  );
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Layout;
